import { clients } from '../../../lib/https';
import { ConfigurationSettings } from '../../../models/configuration-settings';
import { useCommonStore } from 'state/store/common/useCommonStore';
import { ResponseTimeAnalytics } from '/models/websockets.types';

interface FeedbackResponse {
  modified_count: number;
  message: string;
  status: string;
}

interface FeedbackParams {
  conversation_id: string;
  msg_id: string;
  feedback: boolean;
}

interface ResponseAudioParams {
  conversation_id: string;
  msg_id: string;
}

export interface AnalyticsParams {
  conversationId: string;
  messageId: string;
}

export enum Reactions {
  LIKE = 'LIKE',
  DISLIKE = 'DISLIKE',
}

export const sendFeedback = async (
  param: FeedbackParams,
  config: ConfigurationSettings
): Promise<FeedbackResponse> => {
  const currentUser = useCommonStore.getState().user;
  const currentUserId = currentUser?.id;
  if (!currentUserId) {
    throw new Error('User ID is required');
  }
  const payload = {
    conversationId: param.conversation_id,
    messageId: param.msg_id,
    reactions: {
      [param.feedback ? Reactions.LIKE : Reactions.DISLIKE]: {
        emoji: param.feedback ? '👍' : '👎',
        userIds: [currentUserId],
      },
    },
  };

  const baseUrl = `https://${config.paths.taskforceBaseUrl}`;
  const url = `${baseUrl}${config.paths.taskforce.getCollaborationMessages}`;
  return clients.put(url, config.blocksKey, JSON.stringify(payload));
};

export const getResponseAudio = async (param: ResponseAudioParams, config: ConfigurationSettings) => {
  const payload = {
    conversationId: param.conversation_id,
    messageId: param.msg_id,
  };
  
  const baseUrl = `https://${config.paths.taskforceBaseUrl}`;
  const url = `${baseUrl}${config.paths.taskforce.tts}`;
  const response = clients.post(url, config.blocksKey, JSON.stringify(payload)) as Promise<Response>;

  return response;
};

export const getPipelineResponseAnalytics = async (param: AnalyticsParams, config: ConfigurationSettings) => {  
  const baseUrl = `https://${config.paths.taskforceBaseUrl}`;
  const url = `${baseUrl}${config.paths.taskforce.pipelineAnalytics}/conversations/${param.conversationId}/messages/${param.messageId}`;
  const response = clients.get(url, config.blocksKey) as Promise<ResponseTimeAnalytics>;

  return response;
};